/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAuthRouteImport } from './routes/_app/_auth'
import { Route as AppAuthCheckoutRouteImport } from './routes/_app/_auth/checkout'
import { Route as AppAuthHistoryRouteImport } from './routes/_app/_auth/history'
import { Route as AppAuthChargeFailRouteImport } from './routes/_app/_auth/charge/fail'
import { Route as AppAuthChargeSuccessRouteImport } from './routes/_app/_auth/charge/success'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAuthRoute = AppAuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => AppRoute,
} as any)
const AppAuthCheckoutRoute = AppAuthCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => AppAuthRoute,
} as any)
const AppAuthHistoryRoute = AppAuthHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AppAuthRoute,
} as any)
const AppAuthChargeFailRoute = AppAuthChargeFailRouteImport.update({
  id: '/charge/fail',
  path: '/charge/fail',
  getParentRoute: () => AppAuthRoute,
} as any)
const AppAuthChargeSuccessRoute = AppAuthChargeSuccessRouteImport.update({
  id: '/charge/success',
  path: '/charge/success',
  getParentRoute: () => AppAuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/checkout': typeof AppAuthCheckoutRoute
  '/history': typeof AppAuthHistoryRoute
  '/charge/fail': typeof AppAuthChargeFailRoute
  '/charge/success': typeof AppAuthChargeSuccessRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AppIndexRoute
  '/checkout': typeof AppAuthCheckoutRoute
  '/history': typeof AppAuthHistoryRoute
  '/charge/fail': typeof AppAuthChargeFailRoute
  '/charge/success': typeof AppAuthChargeSuccessRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/_auth': typeof AppAuthRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/_auth/checkout': typeof AppAuthCheckoutRoute
  '/_app/_auth/history': typeof AppAuthHistoryRoute
  '/_app/_auth/charge/fail': typeof AppAuthChargeFailRoute
  '/_app/_auth/charge/success': typeof AppAuthChargeSuccessRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/checkout'
    | '/history'
    | '/charge/fail'
    | '/charge/success'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/checkout'
    | '/history'
    | '/charge/fail'
    | '/charge/success'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/_auth'
    | '/_app/'
    | '/_app/_auth/checkout'
    | '/_app/_auth/history'
    | '/_app/_auth/charge/fail'
    | '/_app/_auth/charge/success'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_auth': {
      id: '/_app/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppAuthRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/_auth/checkout': {
      id: '/_app/_auth/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof AppAuthCheckoutRouteImport
      parentRoute: typeof AppAuthRoute
    }
    '/_app/_auth/history': {
      id: '/_app/_auth/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof AppAuthHistoryRouteImport
      parentRoute: typeof AppAuthRoute
    }
    '/_app/_auth/charge/fail': {
      id: '/_app/_auth/charge/fail'
      path: '/charge/fail'
      fullPath: '/charge/fail'
      preLoaderRoute: typeof AppAuthChargeFailRouteImport
      parentRoute: typeof AppAuthRoute
    }
    '/_app/_auth/charge/success': {
      id: '/_app/_auth/charge/success'
      path: '/charge/success'
      fullPath: '/charge/success'
      preLoaderRoute: typeof AppAuthChargeSuccessRouteImport
      parentRoute: typeof AppAuthRoute
    }
  }
}

interface AppAuthRouteChildren {
  AppAuthCheckoutRoute: typeof AppAuthCheckoutRoute
  AppAuthHistoryRoute: typeof AppAuthHistoryRoute
  AppAuthChargeFailRoute: typeof AppAuthChargeFailRoute
  AppAuthChargeSuccessRoute: typeof AppAuthChargeSuccessRoute
}

const AppAuthRouteChildren: AppAuthRouteChildren = {
  AppAuthCheckoutRoute: AppAuthCheckoutRoute,
  AppAuthHistoryRoute: AppAuthHistoryRoute,
  AppAuthChargeFailRoute: AppAuthChargeFailRoute,
  AppAuthChargeSuccessRoute: AppAuthChargeSuccessRoute,
}

const AppAuthRouteWithChildren =
  AppAuthRoute._addFileChildren(AppAuthRouteChildren)

interface AppRouteChildren {
  AppAuthRoute: typeof AppAuthRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAuthRoute: AppAuthRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
